import { SNAPPEA_TOKEN, USER_ID, USER_EMAIL, VENDORS } from '@/constants';

export const getSessionToken = () => localStorage.getItem(SNAPPEA_TOKEN);
export const getUserId = () => localStorage.getItem(USER_ID);
export const getUserEmail = () => localStorage.getItem(USER_EMAIL);
export const getVendorIds = () => {
  try {
    return JSON.parse(localStorage.getItem(VENDORS) ?? '[]').map(
      (v: { id: string; name: string }) => v.id
    );
  } catch (e) {
    console.error(`Failed to parse stored ${VENDORS}`, e);
    return [];
  }
};
export const getVendors = () => {
  try {
    return JSON.parse(localStorage.getItem(VENDORS) ?? '[]');
  } catch (e) {
    console.error(`Failed to parse stored ${VENDORS}`, e);
    return [];
  }
};

export const setSessionToken = (token: string) => localStorage.setItem(SNAPPEA_TOKEN, token);
export const setUserId = (userId: string) => localStorage.setItem(USER_ID, userId);
export const setUserEmail = (email: string) => localStorage.setItem(USER_EMAIL, email);
export const setVendors = (vendors: { id: string; name: string }[]) =>
  localStorage.setItem(VENDORS, JSON.stringify(vendors));

export const clearSession = () => {
  localStorage.removeItem(SNAPPEA_TOKEN);
  localStorage.removeItem(USER_ID);
  localStorage.removeItem(USER_EMAIL);
  localStorage.removeItem(VENDORS);
};
